export default __webpack_public_path__ + "static/media/testo.91aef577.svg";